module.exports = __webpack_public_path__ + "media/images/icons/flags/SI-999969caef88d0b63a1457dfb96d8756.svg";